<script setup lang="tsx">
import type { RiskConfig, RiskOverviewCriticalAsset } from '@/models/api-generated'
import CardRow from './CardRow.vue'
import RiskScoreBadge from '../RiskScoreBadge.vue'
import { truncate, averageResidual } from '@/services/utils'
import { h } from 'vue'
import RisksTooltip from '../RisksTooltip.vue'

const props = defineProps<{
	config?: RiskConfig
}>()

const model = defineModel<RiskOverviewCriticalAsset[]>({ required: true })

function goToAssets(asset: string) {
	const params = new URLSearchParams({
		name: asset,
	})
	window.location.href = `/app/assets?${params}`
}

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(names: string[]) {
	if (!names) return
	emit('go-to-risks', names, [])
}
</script>

<template>
	<div class="rounded-container p-4 pe-4 overflow-auto text-nowrap">
		<p class="text-center fw-bold">
			{{ $t('risk.overview.criticalAssets') }}
		</p>

		<table class="w-100">
			<CardRow :underline="true">
				<template #col0>&nbsp;</template>
				<template #col1>{{ $t('risk.risk', 1) }}</template>
				<template #col2>{{ $t('price') }}</template>
				<template #col3>{{ $t('risk.residualRiskScore') }}</template>
			</CardRow>

			<CardRow v-for="a in model" :key="a.name">
				<template #col0>
					<span v-one-tooltip="a.name" @click="goToAssets(a.name)" class="risks-cell">{{ truncate(a.name, 10) }}</span>
				</template>
				<template #col1>
					<div
						class="text-center risks-cell"
						v-one-tooltip="{
							content: () => h(RisksTooltip, { risks: a.risks, config: props.config }),
						}"
						@click="goToRisks(a.risks.map((r) => r.name))"
					>
						{{ a.risks.length }}
					</div>
				</template>
				<template #col2>{{ a.price }} € </template>
				<template #col3><RiskScoreBadge :model-value="averageResidual(a.risks)" :config="props.config" /></template>
			</CardRow>
		</table>
	</div>
</template>
